
import { VSkeletonLoader } from "vuetify/lib";

export default VSkeletonLoader.extend({});
